import { For } from "solid-js";
import { Spacer } from "~/widgets/spacer";
import { FAQ } from "~/data/static_faqs/types";

//

export default function PartnerFAQs(props: { faqs: FAQ[] }) {
  return (
    <div class="w-full max-w-[800px] px-4 py-8 sm:px-6">
      <h2 class="darkTheme:text-textLight text-center text-[32px] font-semibold text-textDark">
        Frequently Asked Questions
      </h2>
      <Spacer height={40} />

      <div class="flex flex-col gap-4">
        <For each={props.faqs}>
          {(faq) => (
            <div class="rounded-lg border border-[#E5E7EB] bg-white darkTheme:border-[#212427] darkTheme:bg-[#1A1C1E]">
              <div class="px-6 py-4">
                <h3 class="darkTheme:text-textLight mb-2 text-[16px] font-medium text-textDark">
                  {faq.question}
                </h3>
                <p class="darkTheme:text-textLight/80 text-[14px] leading-[20px] text-textNormal">
                  {faq.answer}
                </p>
              </div>
            </div>
          )}
        </For>
      </div>
    </div>
  );
}
